import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Observable, throwError } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { url } from 'src/environments/environment.prod';
import { LoginResponse } from './loginResponse';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  @Output() loggedIn: EventEmitter<boolean> = new EventEmitter();
  @Output() username: EventEmitter<string> = new EventEmitter();

  getUserName() {
    return this.localStorage.retrieve('username');
  }
  getRefreshToken() {
    return this.localStorage.retrieve('refreshToken');
  }

  isLoggedIn(): boolean {
    return this.getJwtToken() != null;
  }


  constructor(
    private httpClient: HttpClient,
    private localStorage: LocalStorageService
  ) {

  }

  login(username: string, password: string): Observable<boolean> {
    return this.httpClient.post<LoginResponse>(url + '/auth/login', { 'username': username, 'password': password }).pipe(map(data => {
      this.localStorage.store('authenticationToken', data.authenticationToken);
      this.localStorage.store('username', data.username);
      this.localStorage.store('refreshToken', data.refreshToken);
      this.localStorage.store('expiresAt', data.expiresAt);
      this.loggedIn.emit(true);
      this.username.emit(data.username);
      return true;
    }));
  }

  logout() {
    this.httpClient.post(url + '/auth/logout', { 'refreshToken': this.getRefreshToken(), 'username': this.getUserName() },
      { responseType: 'text' })
      .subscribe(data => {
        console.log(data);
      }, error => {
        throwError(error);
      })
    this.localStorage.clear('authenticationToken');
    this.localStorage.clear('username');
    this.localStorage.clear('refreshToken');
    this.localStorage.clear('expiresAt');
  }


  register(username: string, password: string): Observable<boolean> {
    return this.httpClient.post<boolean>(url + '/auth/signup', { 'username': username, 'password': password });
  }

  getJwtToken() {
    return this.localStorage.retrieve('authenticationToken');
  }

  refreshToken() {
    return this.httpClient.post<LoginResponse>(url + '/auth/refresh/token',
      { 'refreshToken': this.getRefreshToken(), 'username': this.getUserName() })
      .pipe(tap(response => {
        this.localStorage.clear('authenticationToken');
        this.localStorage.clear('expiresAt');

        this.localStorage.store('authenticationToken',
          response.authenticationToken);
        this.localStorage.store('expiresAt', response.expiresAt);
      }));
  }

}
